<template>
    <NoJurisdiction v-if="noPermission" />
    <router-view v-else-if="this.auditStatus == Const.User.AuditStatus.Pass && loginStatus == 'online'"></router-view>

    <div v-else-if="this.auditStatus != Const.User.AuditStatus.Pass && loginStatus == 'online'" class="message-box">
        <Icon type="ios-alert-outline" size="128" style="color: red"/>
        <h3 style="text-align: center">{{ $t('Main.auditStatusText') }}</h3>
    </div>

    <Spin v-else fix class="spin">
        <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
        <div>{{ $t('loginText') }}</div>
    </Spin>
</template>

<script>
import { mapState } from "vuex";
import "@/assets/main.less";
import logger from '@/assets/log';
import {dynamicRouterMap} from "@/router";
import apimodel from "@/model/ApiModel";
import NoJurisdiction from "@/components/NoJurisdiction.vue";
const log = logger("views:main");

let { Const } = apimodel;

export default {
    name: "MAIN",
    components: { NoJurisdiction },
    mounted() {
        this.$store.dispatch("user/login").then(() => {
            this.$store.dispatch('permission/clearPermissionList');
            if(this.auditStatus != null){
                if(this.auditStatus == Const.User.AuditStatus.Pass){
                    if(this.$store.state.permission.permissionList.length === 0){
                        this.$store.dispatch('permission/FETCH_PERMISSION').then(() => {
                            // 没有子菜单
                            if(!dynamicRouterMap[0].redirect) {
                                this.noPermission = true;
                            }
                        });
                    }
                }else {
                    this.$Notice.error({ title: this.$t('Main.auditStatusMessageTitle'), desc: this.$t('Main.auditStatusMessageDesc') });
                    setTimeout(()=>{
                        // LoginModel.toLogoutPage(this.logoutUrl)
                        window.open(this.indexUrl + 'authentication', '_self');
                    },5000)
                }
            }
        });
    },
    data() {
        return {
            Const,
            noPermission: false
        }
    },
    computed: mapState({
        callResult: state => state.api.callResult,
        loginStatus: state => state.user.status, //status == 'online' 才显示页面
        logoutUrl: state => state.user.logoutUrl,
        indexUrl: state => state.user.indexUrl,
        auditStatus: state => state.user.auditStatus
    }),
    watch: {
        callResult(result) {
            //全局捕捉api调用失败事件，弹出message提示
            if (result.code == 401) {
                //避免重复提示
                this.$Notice.destroy();

                log(this.$t('Message.callResult.requestFailed'));

                this.$Notice.error({
                    title: this.$t('Message.callResult.requestFailed'),
                    desc: result.message
                });
                this.$store.dispatch("user/toLogin", result.data);
            } else if (result.code != 0 && result.code != 200) {
                //避免重复提示
                this.$Notice.destroy();
                this.$Notice.error({
                    title: this.$t('Message.callResult.error'),
                    desc: result.message
                });
            }
        }
    }
};
</script>

<style lang="less" scoped>
    .message-box{
        position: absolute;
        width: 256px;
        height: 256px;
        top: 50%;
        left: 50%;
        text-align: center;
        margin-left: -128px;
        margin-top: -128px;
    }
</style>
